

/**
 * @ngdoc function
 * @name cimerFrontEndApp.controller:UploadDocument
 * @description
 * # UploadDocument
 * Controller of the cimerFrontEndApp
 */

angular.module('cimerFrontEndApp')
  .controller('UploadDocumentCtrl', ['$scope', '$http', '$location', '$timeout', '$q', '$routeParams', 'Session', 'DocumentService', function ($scope, $http, $location, $timeout, $q, $routeParams, Session, DocumentService) {
      'use strict';
      var sessionObject = Session.getSessionObject();
      if (!sessionObject.isAuthenticated || !(sessionObject.isAdmin || sessionObject.isCurriculaAdmin)) {
          $location.url('/');
          return;
      }

      var clearFormData = function () {
          $scope.FormData = {
              FileName: null,
              DocumentType: null,
              ResearchRole: null,
              Context: '',
              Title: '',
              Contents: [],
              Active: true,
              SelectedTags: [],
              PrimaryTag: null
          };

          if ($scope.Tags) {
              for (var i = 0; i < $scope.Tags.length; i++) {
                  var tag = $scope.Tags[i];
                  tag.Selected = false;
              }
          }
      };

      clearFormData();

      $scope.DocumentFileTypes = ['.pdf'];
      $scope.formSubmitted = false;
      $scope.filteredTags = [];
      $scope.showPrimaryTagField = false;
      $scope.traineeDevelopmentTags = [];

      var documentTypes = DocumentService.getDocumentTypes();
      var documentTags = DocumentService.getAllDocumentTags();
      var documentLabels = DocumentService.getAllDocumentLabels();
      var researchRoles = DocumentService.getResearchRoles();

      var functionCalls = [documentTypes, documentTags, documentLabels, researchRoles];

      //See if we've got a document id
      if ($routeParams.documentID) {
          var documentID = $routeParams.documentID;
          functionCalls.push(DocumentService.editDocument(documentID));
          $scope.EditingDocument = true;
      }

      $q.all(functionCalls).then(function (responses) {
          $scope.DocumentTypes = responses[0].data;
          $scope.Tags = responses[1].data;
          $scope.Labels = responses[2].data;
          $scope.ResearchRoles = responses[3].data;

          if ($scope.EditingDocument) {
              $scope.DocumentData = responses[4].data;

              if ($scope.DocumentData) {
                  $scope.FormData.DocumentID = $scope.DocumentData.DocumentID;
                  $scope.FormData.DocumentType = $scope.DocumentData.DocumentType;
                  $scope.FormData.FileName = $scope.DocumentData.FileName;
                  $scope.FormData.Context = $scope.DocumentData.Context;
                  $scope.FormData.Title = $scope.DocumentData.Title;
                  $scope.FormData.Active = $scope.DocumentData.Active;
                  $scope.FormData.DocumentLabel = $scope.DocumentData.DocumentLabel;

                  for (var i = 0; i < $scope.Tags.length; i++) {
                      var tag = $scope.Tags[i];
                      for (var j = 0; j < $scope.DocumentData.DocumentTags.length; j++) {
                          var documentTag = $scope.DocumentData.DocumentTags[j];
                          if (documentTag.Tag.TagId === tag.TagId) {
                              tag.Selected = true;
                              $scope.FormData.SelectedTags.push(tag);
                              if (documentTag.PrimaryTag || false) { // PrimaryTag is a nullable field in the database column, the || false is there in case it is null (equivalent of ?? in C#)
                                  $scope.FormData.PrimaryTag = documentTag.Tag;
                              }
                              break;
                          }
                      }
                  }

                  // A document must have tags in order to determine the research role
                  if ($scope.DocumentData.DocumentTags.length > 0) {
                      for (var i = 0; i < $scope.ResearchRoles.length; i++) {
                          if (+$scope.ResearchRoles[i].Value === $scope.DocumentData.DocumentTags[0].Tag.Category.ResearchRoleID) {
                              setResearchRoleAndUpdateTags($scope.ResearchRoles[i]);
                          }
                      }
                  }

              } else {
                  for (var k = 0; k < $scope.Tags.length; k++) {
                      var newTag = $scope.Tags[k];
                      newTag.Selected = false;
                  }
              }
          }


      }, function () {
          $location.path('error');
      });

      $scope.GetFileData = function (file) {

          $scope.FormData.Contents = file;
      };

      $scope.buttonClass = function () {
          var result = "btn-primary";
          if ($scope.documentUploadForm.documentType.$invalid && $scope.formSubmitted) {
              result = "btn-danger";
          }

          return result;
      };

      $scope.documentTypeRadioClicked = function ($event, documentType) {
          $event.preventDefault();
          $event.stopPropagation();
          $scope.FormData.DocumentType = documentType;
      };

      var filterTags = function (researchRoleID) {
          $scope.filteredTags = [];
          angular.forEach($scope.Tags,
              function(tag) {
                  if (tag.Category.ResearchRoleID.toString() === researchRoleID) {
                      $scope.filteredTags.push(tag);
                  }
              });
          $scope.filteredTags = $scope.filteredTags.sort(function(a, b) {
              return (a.Description > b.Description) ? 1 : ((b.Description > a.Description) ? -1 : 0);
          });
      };

      /* This function determines if the primary tag field should be displayed based on the currently selected document tags and displays the field if it should (via $scope.showPrimaryTagField). 
       * It should be called whenever the document tags or document type (mentor vs mentee) are updated.
       */
      var checkPrimaryTagDisplay = function () {
          $scope.traineeDevelopmentTags = [];
          // Only trainee documents (ResearchRole.Value 2) can have a primary tag
          if ($scope.FormData.ResearchRole === null || $scope.FormData.ResearchRole.Value !== "2") {
              $scope.FormData.PrimaryTag = null;
              $scope.showPrimaryTagField = false;
              return;
          }

          var tagList = $scope.FormData.SelectedTags;
          // Add any trainee development tags (tags with CategoryID = 4) to the array of primary tag candidates
          for (var i = 0; i < tagList.length; i++) {
              var tag = tagList[i];
              if (tag.Category.CategoryID === 4) {
                  if ($scope.traineeDevelopmentTags.indexOf(tag) < 0) {
                      $scope.traineeDevelopmentTags.push(tag);
                      $scope.showPrimaryTagField = true;
                  }
              }
          }

          // Hide primary tag field and set primary tag to null if there are no trainee development tags
          if ($scope.traineeDevelopmentTags.length < 1) {
              $scope.FormData.PrimaryTag = null;
              $scope.showPrimaryTagField = false;
          }
      };

      var setResearchRoleAndUpdateTags = function (researchRole)
      {
          $scope.FormData.ResearchRole = researchRole;
          filterTags(researchRole.Value);
          checkPrimaryTagDisplay();
      };

      $scope.researchRoleRadioClicked = function ($event, researchRole) {
          $event.preventDefault();
          $event.stopPropagation();
          // Upon changing the role, clear the tags since mentor and mentee roles have different sets of tags
          if ($scope.FormData.ResearchRole !== researchRole) {
              $scope.FormData.SelectedTags = [];
              $scope.FormData.PrimaryTag = null;
              // Also uncheck all the tags that are checked so that it matches up with what is in the SelectedTags array
              // Not too concerned about the performance being poor here because going back and forth a lot would be unusual for an admin to do in this workflow
              for (var i = 0; i < $scope.Tags.length; i++) {
                  var tag = $scope.Tags[i];
                  tag.Selected = false;
              }
          }
          setResearchRoleAndUpdateTags(researchRole);
      };

      $scope.onTagsUpdated = function (tag) {

          // Update SelectedTags array
          if (tag.Selected) {
              // Tag added to the document
              $scope.FormData.SelectedTags.push(tag);
          }
          else {
              // Tag removed from the document
              var index = $scope.FormData.SelectedTags.indexOf(tag);
              if (index > -1) {
                  $scope.FormData.SelectedTags.splice(index, 1);
              }
          }

          checkPrimaryTagDisplay();
      };

      $scope.uploadDocument = function () {
          $scope.formSubmitted = true;
          if ($scope.documentUploadForm.$invalid) {
              return;
          }

          $scope.Uploading = true;

          DocumentService.uploadDocument($scope.FormData).then(function (response) {
              $scope.Uploading = false;             
              if (response && response.data) {
                  $scope.formSubmitted = false;

                  $scope.documentSaved = true;
                  $timeout(function () {
                      $scope.documentSaved = false;
                  }, 3000);

                  if (!$scope.EditingDocument) {
                      clearFormData();
                      $scope.clearUpload = true;
                  }
              }
          }).catch(function (err) {
              $scope.documentError = true;
              console.log(err);
          });


      };
    }]);